<template>
	<div class="Index">
		<div class="search">
			<div class="search-input">
				<van-icon name="search" />
				<input type="text" placeholder="请输入搜索关键词" @focus="goSearch">
			</div>
		</div>
		<div class="swiper-img">
            <van-swipe :autoplay="3000" indicator-color="white">
				<van-swipe-item v-for="(item,index) in swiperImg" :key="index" @click="clickSwiperImg(item)">
					<a :href="item.link">
                        <img :src="item.image" alt="">
                    </a>
				</van-swipe-item>
			</van-swipe>
			<!-- <img :src="bannerImg" alt=""> -->
		</div>
		<div class="articles">
			<van-tabs v-model="active" color="#901d22" title-inactive-color="#999" title-active-color="#333"  @change="changeTab">
				<van-tab :title="item.name"  v-for="(item,index) in channelsList" :key="index">
					<div class="content">
						<!-- <div class="titleWrap"> -->
                            <van-tabs v-model="sonactive" v-if="item.son.length>0" type="card" @change="function(index,title){return changeSonTab(index,title,item.son)}" color="#901d22" title-inactive-color="#999" title-active-color="#fff">
                                <van-tab :title="val.name" v-for="(val) in item.son" :key="val.id">
                                    <div class="list">
                                        <van-empty description="暂无数据哦..."  v-if="isEmpty"/>
                                        <row-item-list :list="articlesList" v-else></row-item-list>
                                    </div>
                                </van-tab>
                            </van-tabs>
                             <van-empty description="暂无数据哦..."  v-if="!item.son.length>0"/>
					</div>
				</van-tab>
			</van-tabs>
		</div>
	</div>
</template>
<script>
	import Banner from "@/components/Banner.vue";
    import Tabbar from '@/components/Tabbar.vue';
    import RowItemList from "@/components/RowItemList.vue"
    import {ModulesRecommend,InformationMenu,InformationDetails,ArticlesCollect,IndexBanner} from "@/config/interface.js"
	export default{
		components:{
			Banner,
    		Tabbar,
    		RowItemList
		},
		data(){
			return{
				isEmpty:false,   //列表数据是否为空
				active:0,           //tabbar的index
				sonactive:0,        //title默认的index
				articlesList:[],   //文章列表
				columnsList:[],    //专栏列表
				channelsList:[],           //频道列表
				channel_id:0,         //频道id
                sonChannel_id:0,      //子频道id
                swiperImg:[],
				swiperOption: {
					direction: 'horizontal',
	                loop: true,
	                autoplay: 3000,
	                slidesPerView: "auto",
	                centeredSlides:true,
	                spaceBetween: 10,
			        pagination: {
			            el: '.swiper-pagination',
			            clickable: true
			        }
        		}
			}
		},
		beforeRouteEnter(to, from, next) {
            //  修复iOS版微信HTML5 History兼容性问题
            if (to.path !== location.pathname) {
                //console.log("检测完成")
                // 此处不可使用location.replace
                location.assign(to.fullPath)
            } else {
                next()
            }
        },
		mounted(){
			this.channel_id=this.$route.query.channel_id;
			this.sonChannel_id=this.$route.query.channel_id;
			this.active=this.channel_id==21?2:0;      //MM学院默认第三个
			let obj={
				channel_id:this.channel_id
			}
			localStorage.setItem('channel_id',JSON.stringify(obj));
			// document.title=language.CHANNEL_LIST[this.channel_id].title;
			this.getChannels();
			// common.wxShare(document.title,language.CHANNEL_LIST[this.channel_id].desc,language.CHANNEL_LIST[this.channel_id].img);
		},
		watch:{
			    // '$store.state.Loading':(newVal,oldVal)=>{
			    //   	this.loading=newVal;
			    // }			
		},
		methods:{
			//跳转专栏详情
			skipColumnDetails(id){
				this.$router.push({
					path:'/column/details',
					query:{
						id:id
					}
				})
			},
			//频道目录
			getChannels(){
				const url=InformationMenu;
				let params={
					channel_id:this.channel_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
                        this.channelsList=res.data;
                        this.sonChannel_id=res.data[0].id; 
                        this.swiperImg=res.data[0].images; 
						this.getlist();
					}
				})
			},
			//列表
			getlist(){
				const url=InformationDetails;
				let params={
					channel_id:this.sonChannel_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						var data=res.data;
						this.articlesList=data.articles;
						this.isEmpty=data.articles.length==0?true:false;
						let my_favorites=data.my_favorites;
						this.articlesList.forEach((item,index)=>{
							item.release_at=item.release_at==null?'':common.splitString(item.release_at,' ',0);
							this.$set(item,'isCollect',my_favorites[item.id]);
						})

					}
				})
			},
			//切换tab标签时触发
			changeTab(index,title){
				this.sonChannel_id=this.channelsList[index].son.length>0?this.channelsList[index].son[0].id:this.channelsList[index].id;
                this.sonactive=0;
				this.swiperImg=this.channelsList[index].images;
				this.getlist();
			},
			//切换子tab
			changeSonTab(index,title,item){
                this.sonactive=index;
				this.sonChannel_id=item[index].id;
				this.getlist();
			},
			
			//去搜索
			goSearch(){
				this.$router.push({path:'/vow/search'})
			}
		}
	}
</script>
<style lang="scss">
	.Index{
		//轮播
		.swiper-img{
			margin:0 auto;
			padding:0px 12px;
			box-sizing:border-box;
			.van-swipe-item{
                a{
                    display: block;
                }
				img{
					width:100%;
					border-radius:5px;
				}
			}
		}
        .van-tabs__nav--card{
            margin:0px;
        }
		/*动画*/
		.rotate-active{
			animation: rotate-in 1s;
		}
		@keyframes rotate-in{
			0%{
				transform: rotate(0);
			}
			100%{
				transform: rotate(360deg);
			}
		}
		/*搜索*/
		.search{
			padding:8px 12px;
			@include flex(row);
			align-items:center;
			justify-content:space-between;
			.avatar{
				img{
					width:35px;
					height:35px;
					border-radius:100%;
				}
			}
			.search-input{
				@include flex(row);
				align-items:center;				
				flex:1;
				background: #F2F2F2;
				border: 1px solid #BFBFBF;
				border-radius: 16px;
				height:35px;
				padding:0px 5px;
				padding-left:10px;
				margin:0 8px;
				i{
					font-size:20px;
					color:#999;
				}
				input{
					flex:1;
					font-size:14px;
					color:#999;
					height:100%;
					padding-left:10px;
					background:transparent;
					border:0px;
				}
			}
			.attentiontBtn{
				width: 62px;
				height:35px;
				line-height:35px;
				font-size:14px;
				color:#fff;
				text-align: center;
				background: #FF504F;
				border-radius: 35px;
				border-radius: 35px;
			}
		}
		/*轮播图*/
		.swiper-img{
			img{
				border-radius:5px;
				width:100%;
				height:100%;
			}
		}
		.head{
			height:50px;
			line-height:50px;
			h3{
			font-size: 17px;
			color: #090909;
			letter-spacing: 0.6px;
			}	
		}
		.articles{
			.van-ellipsis{
				font-size:15px;
			}
			.van-tabs__nav{
				position: relative;
				z-index:6;
			}
			.content{
				width:94%;
				margin:18px auto;
				background: #FFFFFF;
				box-shadow: 0 0 9px 0 rgba(0,0,0,0.15);
				.titleWrap{
					position:relative;
					height:45px;
					line-height:45px;
					clear: both;
					div{
						float:left;
						width:56%;
						font-weight: bold;
    					letter-spacing: 1px;
						font-size:15px;
						text-align:center;
						background:#f4f4f4;
					}
					div.active{
						width:44%;
						background:#fff;
					}
					.uppertrian{
							position:absolute;
							left:50%;
							top:0;
							border-style: solid;
							border-color:transparent transparent #fff;
							border-width:45px;
							transform: translate(-75%,-50%);
    						z-index: 3;
						}
					div.active{
						background:#fff;
						color:#333	
					}
					
				}
				.list{
					height:410px;
					overflow: auto;
				}
			}
		}
		.van-overlay{
			display:block;
			z-index:100;
			.tip{
				width: 70%;
				position: absolute;
				right: 20px;
				top: 0;
			}
			.know{
				width:120px;
				position: absolute;
				bottom: 50px;
				left:50%;
				transform: translate(-50%,0);
				width:130px;
				
			}
		}
        .van-empty{
            height:410px;
            box-sizing: border-box;
        }

	}
</style>


// WEBPACK FOOTER //
// src/pages/Vow/Index.vue